import { PAccordion } from '@porsche-design-system/components-react';
import React, { memo, useEffect, useState } from 'react';
import { IssueCard } from './IssueCard';

export const EpicFlyout = memo(({ onClose, epicName, flyoutData, versions }) => {
  const [flyoutExpanded, setFlyoutExpanded] = useState({});

  useEffect(() => {
    const initial = {};
    Object.keys(flyoutData).forEach((key) => {
      initial[key] = true;
    });
    setFlyoutExpanded(initial);
  }, [flyoutData]);

  return (
    <div
      className="h-[calc(100vh-80px)] fixed top-16 right-8 z-50 w-full max-w-md bg-white rounded-2xl shadow-xl border p-6 overflow-y-auto custom-scroll"
      style={{
        /* Todo: external class */
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      }}
    >
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">{epicName || 'Flyout-Inhalt'}</h2>
        <button onClick={onClose} className="text-gray-500 hover:text-black text-xl">
          &times;
        </button>
      </div>

      <div className="text-sm text-gray-700 space-y-4">
        {Object.entries(flyoutData)
          .sort(([a], [b]) => {
            if (a === 'Unassigned') return -1;
            if (b === 'Unassigned') return 1;
            return versions.indexOf(a) - versions.indexOf(b);
          })
          .map(([version, issues]) => (
            <PAccordion
              key={version}
              heading={version}
              headingTag="h4"
              open={!!flyoutExpanded[version]}
              onUpdate={() =>
                setFlyoutExpanded((prev) => ({
                  ...prev,
                  [version]: !prev[version],
                }))
              }
            >
              {issues.map((issue) => (
                <IssueCard key={issue.key} issue={issue} />
              ))}
            </PAccordion>
          ))}
      </div>
    </div>
  );
});
